import { Component, OnInit } from '@angular/core';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import {  ListTableComponent  } from '@ppl/ui';
import { ButtonComponent } from '@ppl/ui';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'ppl-payroll-processing',
  standalone: true,
  imports: [ListTableComponent, ButtonComponent],
  templateUrl: './payroll-processing.component.html',
  styleUrl: './payroll-processing.component.css',
})
export class PayrollProcessingComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_PAYROLL_PROCESSING_DATA;
  pageId: string = PAGE_CONSTANTS.PAYROLL_PROCESSING_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  programName!: string;

  constructor(
    private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }

  rowClicked(event: any) {
    console.log('Event', event);
  }
}
